export const handleEnterKeyDown = async (event, cb) => {
  if (event.key == 'Enter') {
    event.stopPropagation();
    event.preventDefault();

    if (cb && typeof cb === 'function') {
      await cb();
    }
  }
};

export const parseBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return false;
};